<div class="disponibilitate-container" *ngIf="saptamani.length > 0">

    <!-- TOOLBAR: filtru specialist + selectie automata + progres -->
    <div class="toolbar">
        <div class="toolbar-left">

            <!-- Filtru specialist -->
            <mat-form-field class="specialist-filter" appearance="outline">
                <mat-label>Specialist</mat-label>
                <mat-select [(ngModel)]="selectedSpecialistId" (ngModelChange)="onSpecialistFilterChange()">
                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                    <mat-option *ngFor="let spec of specialistiOptions" [value]="spec.specialist_id">
                        {{ spec.nume_specialist }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Buton selectie automata -->
            <button type="button" class="auto-select-btn" [disabled]="!canSelectieAutomata"
                (click)="onSelectieAutomata()">
                <mat-icon>auto_fix_high</mat-icon>
                SELECȚIE AUTOMATĂ
            </button>

            <span class="auto-select-hint" *ngIf="!canSelectieAutomata">
                Configurați complet o săptămână pentru a activa
            </span>
        </div>

        <div class="toolbar-right">
            <div class="progres-info">
                <span class="progres-label">Ședințe selectate:</span>
                <span class="progres-value">{{ nrSelectiiComplete }} / {{ nrSedinte }}</span>
            </div>
            <div class="progres-bar">
                <div class="progres-bar__fill" [style.width.%]="progressPercent"></div>
            </div>
        </div>
    </div>

    <!-- LISTA SAPTAMANI -->
    <div class="saptamani-list">

        <div *ngFor="let sapt of saptamani" class="week-card" [ngClass]="getStatusClass(sapt)">

            <!-- HEADER SAPTAMANA -->
            <div class="week-card__header">
                <div class="week-card__header-left">
                    <span class="week-badge" [ngClass]="{
                        'week-badge--complete': isComplete(sapt) && !sapt.isSkipped,
                        'week-badge--skipped': sapt.isSkipped,
                        'week-badge--no-slots': hasNoSlots(sapt) && !sapt.isSkipped,
                        'week-badge--pending': !isComplete(sapt) && !sapt.isSkipped && !hasNoSlots(sapt)
                    }">
                        <span *ngIf="sapt.isSkipped">SĂRIT</span>
                        <span *ngIf="!sapt.isSkipped && isComplete(sapt)">✓ COMPLET</span>
                        <span *ngIf="!sapt.isSkipped && !isComplete(sapt) && !hasNoSlots(sapt)">DE SELECTAT</span>
                        <span *ngIf="!sapt.isSkipped && hasNoSlots(sapt)">FĂRĂ SLOTURI</span>
                    </span>
                    <span class="week-label">{{ sapt.weekLabel }}</span>
                </div>

                <div class="week-card__header-right">

                    <!-- Toggle ședință activă (frecventa=2) -->
                    <div class="sedinta-toggle"
                        *ngIf="frecventa === 2 && !sapt.isSkipped && !hasNoSlots(sapt) && !isComplete(sapt)">
                        <button type="button" class="sedinta-toggle-btn"
                            [class.sedinta-toggle-btn--active]="getActiveSedintaIndex(sapt.weekIndex) === 0"
                            (click)="activeSedintaIndex.set(sapt.weekIndex, 0)">
                            Ședința 1
                            <span class="sedinta-check" *ngIf="getSelectedSedinta(sapt.weekIndex, 0)">✓</span>
                        </button>

                        <!-- Ședința 2: vizibilă doar dacă săptămâna permite >= 2 ședințe -->
                        <button type="button" class="sedinta-toggle-btn"
                            *ngIf="getMaxSedintePentruSaptamana(sapt.weekIndex) >= 2"
                            [class.sedinta-toggle-btn--active]="getActiveSedintaIndex(sapt.weekIndex) === 1"
                            [disabled]="!getSelectedSedinta(sapt.weekIndex, 0)"
                            (click)="activeSedintaIndex.set(sapt.weekIndex, 1)">
                            Ședința 2
                            <span class="sedinta-check" *ngIf="getSelectedSedinta(sapt.weekIndex, 1)">✓</span>
                        </button>
                    </div>

                    <!-- Buton skip: ascuns complet la ultima săptămână validă din interval -->
                    <button type="button" class="skip-btn"
                        *ngIf="!isComplete(sapt) && !hasAnySedinta(sapt.weekIndex) && !isUltimaSaptamanaValida(sapt)"
                        [class.skip-btn--active]="sapt.isSkipped" (click)="toggleSkip(sapt)">
                        {{ sapt.isSkipped ? 'ANULEAZĂ SKIP' : 'SKIP SĂPTĂMÂNĂ' }}
                    </button>

                </div>
            </div>

            <!-- BODY: mesaj skip -->
            <div class="week-card__body" *ngIf="sapt.isSkipped">
                <div class="skipped-message">
                    <mat-icon>event_busy</mat-icon>
                    <span>Săptămâna aceasta a fost sărită. O săptămână extra a fost adăugată la final.</span>
                </div>
            </div>

            <!-- BODY: fără sloturi -->
            <div class="week-card__body" *ngIf="!sapt.isSkipped && hasNoSlots(sapt)">
                <div class="no-slots-message">
                    <mat-icon>info_outline</mat-icon>
                    <span>Nu există sloturi disponibile în această săptămână pentru preferințele selectate.</span>
                </div>
            </div>

            <!-- BODY: sloturi disponibile -->
            <div class="week-card__body" *ngIf="!sapt.isSkipped && !hasNoSlots(sapt)">

                <!-- Hint + sloturi — ascunse când săptămâna e completă -->
                <ng-container *ngIf="!isComplete(sapt)">
                    <div class="sedinta-hint" *ngIf="frecventa === 2">
                        <span
                            *ngIf="getActiveSedintaIndex(sapt.weekIndex) === 0 && getMaxSedintePentruSaptamana(sapt.weekIndex) === 1">
                            Selectați ora pentru <strong>Ședința 1</strong>
                            <em> (doar o ședință mai este necesară în total)</em>
                        </span>
                        <span
                            *ngIf="getActiveSedintaIndex(sapt.weekIndex) === 0 && getMaxSedintePentruSaptamana(sapt.weekIndex) >= 2">
                            Selectați ora pentru <strong>Ședința 1</strong>
                        </span>
                        <span *ngIf="getActiveSedintaIndex(sapt.weekIndex) === 1">
                            Selectați ora pentru <strong>Ședința 2</strong>
                            <em> (ziua trebuie să fie după Ședința 1 și diferită)</em>
                        </span>
                    </div>

                    <!-- Specialiști + sloturi -->
                    <div class="specialist-section" *ngFor="let spec of sapt.specialistiDisponibili">
                        <div class="specialist-header">
                            <mat-icon>person_outline</mat-icon>
                            <span class="specialist-name">{{ spec.nume_specialist }}</span>
                            <span class="specialist-locatie">— {{ spec.denumire_locatie }}</span>
                        </div>

                        <div class="zile-disponibile">
                            <div class="zi-row" *ngFor="let zi of spec.zileDisponibile"
                                [class.zi-row--blocked]="isDayBlockedForCurrentSedinta(sapt.weekIndex, zi.date) || isDayBeforeSedinta1(sapt.weekIndex, zi.date)">

                                <span class="zi-label">{{ zi.dateFormatted }}</span>

                                <div class="slots-row">
                                    <ng-container *ngIf="frecventa === 1">
                                        <button *ngFor="let slot of zi.slots" type="button" class="slot-btn"
                                            [class.slot-btn--selected]="isSlotSelected(sapt.weekIndex, 0, zi.date, slot.slot_id)"
                                            (click)="selectSlot(sapt, spec, zi, slot)">
                                            {{ formatTime(slot.time_from) }}
                                        </button>
                                    </ng-container>

                                    <ng-container *ngIf="frecventa === 2">
                                        <button *ngFor="let slot of zi.slots" type="button" class="slot-btn"
                                            [class.slot-btn--selected]="isSlotSelected(sapt.weekIndex, getActiveSedintaIndex(sapt.weekIndex), zi.date, slot.slot_id)"
                                            [class.slot-btn--other-sedinta]="isSlotSelected(sapt.weekIndex, getActiveSedintaIndex(sapt.weekIndex) === 0 ? 1 : 0, zi.date, slot.slot_id)"
                                            [disabled]="isDayBlockedForCurrentSedinta(sapt.weekIndex, zi.date) || isDayBeforeSedinta1(sapt.weekIndex, zi.date)"
                                            (click)="selectSlot(sapt, spec, zi, slot)">
                                            {{ formatTime(slot.time_from) }}
                                        </button>
                                    </ng-container>
                                </div>

                                <!-- Înlocuiește zi-blocked-label existent cu acesta: -->
                                <div class="zi-blocked-label"
                                    *ngIf="getBlockedLabelForDay(sapt.weekIndex, zi.date) as blockedLabel">
                                    {{ blockedLabel }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Sumar selecție cu buton X -->
                <div class="week-selectie-sumar" *ngIf="selectii.get(sapt.weekIndex)?.sedinte?.length">
                    <div class="sumar-sedinta" *ngFor="let sed of getSedinteSortate(sapt.weekIndex)">
                        <mat-icon>check_circle</mat-icon>
                        <span>
                            Ședința {{ sed.sedintaIndex + 1 }}:
                            <strong>{{ sed.date | date:'dd MMM yyyy' }}</strong>
                            la <strong>{{ formatTime(sed.slot.time_from) }}</strong>
                            <span class="sumar-specialist">
                                — {{ sed.nume_specialist }}
                                <ng-container *ngIf="sed.denumire_locatie"> ({{ sed.denumire_locatie }})</ng-container>
                            </span>
                        </span>
                        <button type="button" class="remove-sedinta-btn" (click)="removeSedinta(sapt, sed)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

            </div>
        </div>

    </div>

    <!-- BUTON CONFIRMARE -->
    <div class="confirmare-row">
        <div class="confirmare-info" *ngIf="!isFormValid">
            Mai sunt necesare <strong>{{ nrSedinte - nrSelectiiComplete }}</strong> selecții
        </div>
        <button type="button" class="disponibilitate-btn" [disabled]="!isFormValid" (click)="onConfirma()">
            CONFIRMĂ PROGRAMAREA
        </button>
    </div>

</div>

<!-- Empty state -->
<div class="empty-disponibilitate" *ngIf="slotsResponse && saptamani.length === 0">
    <mat-icon>search_off</mat-icon>
    <span>Nu s-au găsit sloturi disponibile pentru criteriile selectate.</span>
</div>